import 'whatwg-fetch'
import InfraUtil from './InfraUtil'

import { Dot, ConnectedDot } from '../Domain/Dot'
import Resource from '../Infra/Resource'

export const connectedDotFromWebdotpod = (platename, name, id) => {
  const path = `webdotplates/${platename}.webdotplate/${name}.webdotpod`
  const pathsTextPath = `${path}/Paths.txt`
  const pathsTextUrl = new URL(pathsTextPath, InfraUtil.rootURL())
  return fetch(pathsTextUrl)
  .then(response => response.text())
  .then(text => {
    const paths = text.split('\n')
    .sort((a, b) => { return a.localeCompare(b, undefined, { numeric : true }) })
    const resources = Resource.arrayFrom(paths, path)
    const connectedDot = processResources(resources)
    connectedDot.id = id
    return connectedDot
  })
}

function processResources(resources) {
  var connectedDots = null
  for (const resource of resources) {
    switch (resource.ext) {
      case '.txt':
      connectedDots = new ConnectedDot()
      const dot = new Dot(resource)
      connectedDots.dots.push(dot)
      break
      case '.dots':
      connectedDots = new ConnectedDot()
      connectedDots.dots = _processResources(resource.children)
      break
      default:
      console.warn(`Unsupported resource: ${resource}`)
    }

    if (connectedDots !== null) {
      break
    }
  }
  return connectedDots
}

function _processResources(resources) {
  const dots = []
  for (const resource of resources) {
    switch (resource.ext) {
      case '.txt':
      case '.png':
      case '.jpg':
      case '.jpeg':
      dots.push(new Dot(resource))
      break
      default:
      console.warn(`Unsupported resource: ${resource}`)
    }
  }
  return dots
}


// WEBPACK FOOTER //
// ./src/Infra/Webdotpod.js